// Types
import { TAuthState, TAuthAction } from "Types";
// Enums
import { AuthActionTypeEnum } from "Enums";

export const AuthReducer = (state: TAuthState, action: TAuthAction): TAuthState => {
    const { 
        type, 
        newAntiForgeryToken, 
        newUserEmail, 
        newIgorAIEnv, 
        newHasAccessToDynamicDelivery,
        newDynamicDeliveryFreeTrialDaysNumber,
        newOrganizationName
    } = action;

    // First, we figure out what action
    // has been fired:
    switch (type) {
        // Then, for each action
        // we describe an according state update.
        case AuthActionTypeEnum.InitAuthState:
            return {
                ...state,
                antiForgeryToken: newAntiForgeryToken,
                userEmail: newUserEmail,
                igorAIEnv: newIgorAIEnv,
                hasAccessToDynamicDelivery: newHasAccessToDynamicDelivery,
                dynamicDeliveryFreeTrialDaysNumber: newDynamicDeliveryFreeTrialDaysNumber,
                organizationName: newOrganizationName
            };
        // If the action is unknown
        // we return the current state:
        default:
            return state;
    }
};
